import React, { useEffect, useState } from "react";
import inputBgLg from "@assets/images/backgrounds/inputBgLg.webp";
import inputBgMd from "@assets/images/backgrounds/inputBgMd.webp";
import type { IVerifyEmail } from "@src/types/AppTypes";

const VerifyEmail: React.FC<IVerifyEmail> = ({
  verifyemailModal,
  modalBorder,
  setVerifyEmailModal,
  setChangeEmailModal,
  verifyEmailMutate,
  isLoading,
  newEmail,
  currentEmail,
}) => {
  const [change_email_otp, setChange_email_otp] = useState<string>("");
  const [new_email_otp, setNew_email_otp] = useState<string>("");

  // useEffect(() => {
  //   const header = document.getElementById("header");
  //   const footer = document.getElementById("footer");

  //   if (verifyemailModal) {
  //     document.body.style.overflow = "hidden";

  //     if (header) {
  //       header.style.zIndex = "0";
  //     }
  //     if (footer) {
  //       footer.style.zIndex = "-1";
  //     }
  //   }

  //   return () => {
  //     document.body.style.overflow = "auto";
  //     if (header) {
  //       header.style.zIndex = "";
  //     }
  //     if (footer) {
  //       footer.style.zIndex = "";
  //     }
  //   };
  // }, [verifyemailModal]);

  return (
    <div
      className={`fixed size-full bg-[#00000080] top-0 left-0 grid place-items-center z-[999] modal-content ${
        verifyemailModal ? "block" : "hidden"
      }`}
    >
      <div className="max-w-xl py-[5px] w-full bg-gradient-to-b from-blue to-skyblue relative rounded-[5px_30px_40px_0px] max-sm:max-w-[95%]">
        <img
          src={modalBorder}
          className="absolute top-0 left-0 size-full z-[0]"
          alt=""
        />
        <div className="relative z-10 p-10 max-md:p-3 max-md:my-3 max-md:px-6 max-sm:px-4 overflow-auto max-h-[100dvh]">
          <div className="flex items-center gap-3 max-md:gap-2 mb-4 max-md:mb-3">
            <button
              onClick={() => {
                setVerifyEmailModal(false);
                setChangeEmailModal(true);
              }}
              className="text-primary text-3xl max-md:text-2xl block duration-150 hover:scale-95"
              aria-label="Left arrow"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <h2 className="text-primary text-center uppercase text-3xl max-md:text-2xl max-sm:text-xl">
              Verify Email
            </h2>
          </div>
          <button
            onClick={() => {
              setVerifyEmailModal(!verifyemailModal);
              setChange_email_otp("");
              setNew_email_otp("");
            }}
            className="text-primary absolute top-10 max-md:top-0 right-10 max-md:right-5 text-3xl max-md:text-2xl ml-auto block duration-150 hover:scale-95"
            aria-label="Close"
          >
            <i className="ri-close-circle-line"></i>
          </button>

          <span className="text-primary text-center uppercase">
            please enter the verification code sent to your old email address as
            well as the verification code sent to your new email address to
            confirm the change.
          </span>
          <div className="text-center mt-10 max-md:mt-5 max-w-md mx-auto">
            <div className="grid grid-cols-1 gap-5 max-sm:grid-cols-1 text-start mb-8">
              <div>
                <label
                  className="text-primary text-base mb-2 f-family-mochiy-pop block"
                  htmlFor="changeEmailOtp"
                >
                  Verification Code *{" "}
                  <span className="inline-block break-all">{`(${currentEmail})`}</span>
                </label>
                <div className="relative">
                  <input
                    id="changeEmailOtp"
                    value={change_email_otp}
                    onChange={(e) => setChange_email_otp(e.target.value)}
                    className="relative p-5 z-10 text-base w-full bg-transparent text-black placeholder:text-[#9CA3AF] f-family-mochiy-pop"
                    placeholder="Enter"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === "NumpadEnter") {
                        e.preventDefault();
                        document.getElementById("newEmailOtp")?.focus();
                      }
                    }}
                  />
                  <img
                    className="absolute top-0 left-0 size-full"
                    src={inputBgLg}
                    alt=""
                  />
                </div>
              </div>
              <div>
                <label
                  className="text-primary text-base mb-2 f-family-mochiy-pop block"
                  htmlFor="newEmailOtp"
                >
                  Verification Code *{" "}
                  <span className="inline-block break-all">{`(${newEmail})`}</span>
                </label>
                <div className="relative">
                  <input
                    id="newEmailOtp"
                    value={new_email_otp}
                    onChange={(e) => setNew_email_otp(e.target.value)}
                    className="relative p-5 z-10 text-base w-full bg-transparent text-black placeholder:text-[#9CA3AF] f-family-mochiy-pop"
                    placeholder="Enter"
                  />
                  <img
                    className="absolute top-0 left-0 size-full"
                    src={inputBgMd}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <button
              disabled={
                isLoading ||
                change_email_otp.length === 0 ||
                new_email_otp.length === 0
              }
              onClick={async (e) => {
                e.preventDefault();
                await verifyEmailMutate({
                  data: {
                    change_email_otp,
                    new_email_otp,
                    new_email: newEmail,
                  },
                });
                setChange_email_otp("");
                setNew_email_otp("");
              }}
              className="text-2xl max-md:text-xl customized-button w-full"
              aria-label="Verify"
            >
              {isLoading ? (
                <i className="ri-loop-right-line btn-loader"></i>
              ) : (
                "Verify"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
